import { Container } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'
import CADOfferBanner from '../components/cadOfferBanner'

export default function Landing() {
    return (
        <>
            {/*
              Banner sits ABOVE the Container so it spans the full viewport
              width and isn't constrained by the Container's max-width. It
              persists across route changes (Shop ↔ Cart) because Landing
              stays mounted while the Outlet swaps. A user who dismisses on
              the shop page stays dismissed when they navigate to cart.
            */}
            <CADOfferBanner />
            <Container maxWidth="lg">
                <Outlet />
            </Container>
        </>
    )
}
